export default __webpack_public_path__ + "static/media/s2.f98e370a.svg";